/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q5Inputs */

const en_consult_q5 = /** @type {(inputs: Consult_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can we reach you?`)
};

const id_consult_q5 = /** @type {(inputs: Consult_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa dihubungi lewat mana?`)
};

/**
* | output |
* | --- |
* | "How can we reach you?" |
*
* @param {Consult_Q5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q5 = /** @type {((inputs?: Consult_Q5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q5(inputs)
	return en_consult_q5(inputs)
});